exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2v6jKKkuFgXnAMG3RETZq7{margin:8px 0}html[dir] ._2v6jKKkuFgXnAMG3RETZq7:last-child{margin-bottom:0}", ""]);
// Exports
exports.locals = {
	"root": "_2v6jKKkuFgXnAMG3RETZq7"
};